import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, InvoiceService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder, Validators} from '@angular/forms';
import {Invoice, TransactionType} from "../_models";

@Component({
  moduleId: module.id.toString(),
  selector: 'invoice-transfer-credit-form',
  templateUrl: './invoice-transfer-credit.component.html'
})
export class InvoiceTransferCreditComponent extends CrudSavePopupComponent implements OnInit {
  invoice: Invoice;
  transactionTypes = [
    {value: TransactionType.Charge, label: 'Charge'},
    {value: TransactionType.UsageCharge, label: 'Usage'},
    {value: TransactionType.SubscriptionAdjustment, label: 'Subscription Adjustment'},
  ]

  @Input('fromType') fromType: TransactionType = TransactionType.UsageCharge;
  @Input('toType') toType: TransactionType = TransactionType.Charge;

  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected invoiceService: InvoiceService,
              protected alertService: AlertService
  ) {
    super(router, location, route, invoiceService, alertService);
    this.objectName = 'Invoice';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({}));
    super.ngOnInit();
  }

  protected onInputDataChanged() {
    this.invoice = this.inputData;

    if (this.invoice) {
      this.setForm(this.formBuilder.group({
        amount: [null, [Validators.required, Validators.min(0.01)]],
        remove_credit: [false],
        from_type: [this.fromType, Validators.required],
        to_type: [this.toType, Validators.required],
      }));
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid) {
      this.invoiceService.transferCredit(this.invoice.id, this.form.value)
        .subscribe(
          data => {
            this.alertService.success('Credit transferred to subscription..');
            this.onSaveComplete(data);
          },
          error => {
            this.handleSubmitError(error);
            this.loading = false;
          });
    }
  }

}
